import { MessageType } from './messageTypes';

export function displayMessage(
    htmlElement: HTMLElement,
    message: string,
    type: MessageType,
    insertBefore: boolean = false,
    scrollToMessage: boolean = false // New argument for scrolling
): void {
    const existingMessage = document.querySelector('.ambikly-message');
    if (existingMessage) {
        existingMessage.remove(); // Remove any existing messages
    }

    const messageElement = document.createElement('div');
    messageElement.className = `ambikly-message ${type}-message`; // Add class based on message type
    messageElement.innerHTML = message; // Set the plain message
    messageElement.style.display = 'none'; // Initially hide the message
    messageElement.style.marginTop = '10px'; // Add margin for spacing

    if (insertBefore) {
        htmlElement.parentNode?.insertBefore(messageElement, htmlElement); // Insert message before the htmlElement
    } else {
        htmlElement.parentNode?.insertBefore(messageElement, htmlElement.nextSibling); // Insert message after the htmlElement
    }

    // Show the message after inserting
    messageElement.style.display = 'block'; // Show the message

    // Scroll to the message element's parent if scrollToMessage is true
    if (scrollToMessage) {
        const parentElement = messageElement.parentElement;
        if (parentElement) {
            parentElement.scrollIntoView({
                behavior: 'smooth', // Smooth scrolling
                block: 'start',     // Align to the top of the view
            });
        }
    }
}
